import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ResourceTitlesPreview = ({ messages }) => {
    if (!messages) {
        return null;
    }
    return [
        _jsx("div", { style: { display: 'flex', flexDirection: 'column', rowGap: '1rem', padding: '20px' }, children: Object.values(messages).map((value) => (_jsxs("div", { style: {
                    border: '1px solid #D1D5DB',
                    borderRadius: '5px',
                    padding: '40px',
                    color: '#182129',
                    fontSize: '14px',
                    fontWeight: '500',
                    display: 'flex',
                    gap: '8px',
                    background: '#FAFAFA',
                }, children: [_jsx("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { d: 'M19.5 14.25V11.625C19.5 9.76104 17.989 8.25 16.125 8.25H14.625C14.0037 8.25 13.5 7.74632 13.5 7.125V5.625C13.5 3.76104 11.989 2.25 10.125 2.25H8.25M8.25 15H15.75M8.25 18H12M10.5 2.25H5.625C5.00368 2.25 4.5 2.75368 4.5 3.375V20.625C4.5 21.2463 5.00368 21.75 5.625 21.75H18.375C18.9963 21.75 19.5 21.2463 19.5 20.625V11.25C19.5 6.27944 15.4706 2.25 10.5 2.25Z', stroke: '#182129', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) }), _jsx("span", { style: { fontSize: '16px' }, children: value })] }, value))) }, 'resource-titles-root'),
    ];
};
//# sourceMappingURL=resource_titles.preview.component.js.map